import Http from "./http";

export const welcomeEmailTemplateListAPI = (data, options) => {
  return Http.post(`admin/email-templates/getTemplateByEventType`, data, options);
};
